export const OPTHINES = {
         voteName: '2020project/2020greening',
         mustSearch: 'Button',
         buttonBg: '#f4a842',
         number: {
           mustRank: true,
         },
         name: true,
         content: true,
         user: true,
         checkBox: false,
         themeColor: {
           activeBgColor: 'rgb(124, 178, 70)',
           inactiveBgColor: 'rgb(46, 114, 12)',
         },
         tabs: [
           {
             tabName: '竞赛答题',
             tabPath: '/20200324YLLH/index',
           },
           {
             tabName: '相关新闻',
             tabPath: '/20200324YLLH/news',
           },
           {
             tabName: '活动规则',
             tabPath: '/20200324YLLH/rules',
           },
         ],
       };
